<!-- 引換え済みチケット(特付FP)の変更の注意書き -->
<template>
  <div class="purcahsed-change-caution">
    同一の乗車日における変更は、引換え済みの特急券の発車時刻が過ぎるまでの間で、変更後の列車に空席がある限り、何度でも可能です。<br />
    区間変更を希望される場合は、一度、取消しのうえ再度引換えてください。<br />
    また、異なる乗車日への変更は、1回のみ可能です。
  </div>
</template>

<script>
export default {
  name: "MFITTExchangedTicketChangeCaution",
};
</script>
<style lang="scss">
.purcahsed-change-caution {
  border: 1px solid #f4ed9b;
  border-radius: 10px;
  background-color: #fffabe;
  font-size: 13px;
  line-height: 1.5;
  padding: 15px 13px;
  margin: 30px 13px;
}
</style>
